/* eslint-disable jira/filename-case */
import { performPostRequest } from '@atlassian/jira-fetch';

export type SearchIssueType = {
	id: string;
	name: string;
	avatarId: number;
	avatarUrl: string;
};

export type SearchIssueTypesRequest = {
	nameContains: string;
	projectIds?: string[];
	pagination?: {
		startAt?: number;
		max?: number;
	};
};

export type SearchIssueTypesResponse = {
	issueTypes: SearchIssueType[];
};

export const performSearchIssueTypes = (
	request: SearchIssueTypesRequest,
): Promise<SearchIssueTypesResponse> =>
	performPostRequest('/rest/polaris/v2/project/settings/issuetype/picker', {
		body: JSON.stringify(request),
	});
